import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import valueActions from "app/utils/valueActions";
import noteActions from "app/utils/noteActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  mobileIncrease,
} from "app/utils/styleSheet";
import { FontAwesome, MaterialIcons, Feather } from "@expo/vector-icons";

import store from "app/redux/store";
import Hoverable from "app/components/Hoverable";

import DatePicker from "app/components/DatePicker";
import Badge from "app/components/chapter/Badge";

export default class EventEditor extends React.Component {
  static propTypes = {
    category: PropTypes.string,
    // timestamp: PropTypes.string,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      timestamp: props.timestamp,
    };
  }

  render() {
    let { value, category, horizontal } = this.props;
    let { timestamp } = this.state;
    let valueColor = valueHelpers.colorAsHex(value?.color);

    return (
      <View style={[horizontal && { flexDirection: "row" }]}>
        <View
          ref={(ref) => (this.ref = ref)}
          style={[horizontal && { justifyContent: "center" }]}
        >
          <Hoverable>
            {(isHovered) => (
              <View style={[styles.wrapper]}>
                {this.renderBadge()}

                {this.renderTimeElem()}
              </View>
            )}
          </Hoverable>
        </View>
      </View>
    );
  }

  renderTimeElem = () => {
    let { category, value, composer } = this.props;
    let { timestamp } = this.state;
    return (
      <View style={{ flexDirection: "row" }}>
        {
          <DatePicker
            selected={new Date(timestamp)}
            value={new Date(timestamp)}
            onChange={(timestamp) =>
              this.setState({ timestamp, isDirty: true })
            }
            inputStyle={{
              flex: 1,
              paddingHorizontal: sizes.base,
              borderColor: colors.trim,
              borderWidth: 1,
              borderRadius: sizes.borderRadius,
              width: 150,
            }}
          />
        }
        <Feather
          name={composer ? "plus" : "check"}
          style={styles.icon}
          color={colors.foreground}
          onPress={this.submit}
        />
        {["progress", "completion"].includes(category) && !composer && (
          <Feather
            name={"trash-2"}
            style={styles.icon}
            color={colors.foreground}
            onPress={this.handleDelete}
          />
        )}
        {/*<Feather
          name="x"
          style={[styles.icon, { paddingRight: sizes.small }]}
          color={colors.foreground}
          onPress={this.props.onClose}
        />*/}
      </View>
    );
  };

  renderBadge = (leftAlign = true) => {
    let { value, category } = this.props;
    return (
      <View
        style={[{ zIndex: 1 }, !ENV.WEB && { padding: sizes.small }]}
        // pointerEvents="none"
      >
        <Badge
          value={value}
          moment={{ value, category }}
          noTooltip
          onPress={this.props.onClose}
          mobileLarge={true}
          style={{
            transform: [{ scale: 1 }], // override hover scale
          }}
        />
      </View>
    );
  };

  handleDelete = async () => {
    let { category, value } = this.props;
    let { timestamp } = this.state;
    let valueId = value.valueId || value.id || null;
    if (!valueId) {
      alert("missing value id");
      return;
    }
    let res;
    if (category == "progress") {
      res = await valueActions.deleteProgress(value, this.props.timestamp);
    } else if (category == "completion") {
      res = await valueActions.update(valueId, {
        completed: false,
        completed_at: null,
      });
    }
    if (res == true) {
      this.props.onClose();
    } else {
      alert("failed");
    }
  };

  submit = async () => {
    let { category, value, composer } = this.props;
    let { timestamp } = this.state;
    let valueId = value.valueId || value.id || null;
    if (!valueId) {
      alert("missing value id");
      return;
    }
    let res;
    if (category == "creation") {
      res = await valueActions.update(valueId, { created_at: timestamp });
    } else if (category == "completion") {
      res = await valueActions.update(valueId, {
        completed_at: timestamp,
      });
    } else if (category == "progress") {
      value = store.getState().values.find((v) => v.id == valueId);
      console.log(valueId, value, store.getState().values);
      if (!value) {
        alert("value not found");
        return;
      }
      let progressAt = [...value.progress_at];
      let updateIndex = progressAt.indexOf(this.props.timestamp);
      if (updateIndex < 0) {
        alert("no progress at found");
        return;
      }
      progressAt[updateIndex] = timestamp;
      console.log(progressAt);
      res = await valueActions.update(valueId, {
        progress_at: progressAt,
      });
    } else if (composer) {
      res = await valueActions.progress(valueId, timestamp);
      if (res.success) res = true;
    }
    if (res == true) {
      this.props.onClose();
    } else {
      alert("failed");
    }
  };
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    flexDirection: "row",
    // borderWidth: 1,
    borderColor: "red",
  },
  icon: {
    fontSize: sizes.default,
    padding: sizes.small,
    paddingRight: 0,
  },
});
